<!-- Modal Template -->
<ng-template #wagerModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ isEditMode ? 'Edit' : 'Add New' }} Special Wager</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form>
      <div class="form-group">
        <label for="name">Wager Type Name</label>
        <input type="text" class="form-control" id="name" [(ngModel)]="currentWager.name" name="name">
      </div>
      <div class="form-group">
        <label for="trackId">Track ID</label>
        <input type="text" class="form-control" id="trackId" [(ngModel)]="currentWager.trackId" name="trackId">
      </div>
      <div class="form-group">
        <label for="trackAbbr">Track Abbreviation</label>
        <input type="text" class="form-control" id="trackAbbr" [(ngModel)]="currentWager.trackAbbreviation" name="trackAbbr">
      </div>
      <div class="form-group">
        <label for="customAbbr">Custom Abbreviation</label>
        <input type="text" class="form-control" id="customAbbr" [(ngModel)]="currentWager.customTrackAbbreviation" name="customAbbr">
      </div>
      <div class="form-group">
        <label for="trackName">Track Name</label>
        <input type="text" class="form-control" id="trackName" [(ngModel)]="currentWager.trackName" name="trackName">
      </div>
      <div class="form-group">
        <label for="slotCount">Slot Count</label>
        <input type="number" class="form-control" id="slotCount" [(ngModel)]="currentWager.slotCount" name="slotCount">
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="saveWager(modal)">Save</button>
  </div>
</ng-template>

<ng-container *ngIf="uniqueSpecialWagerTypes === null">Loading...</ng-container>
<ng-container *ngIf="uniqueSpecialWagerTypes !== null">
  <h1 class="text-center">Special Wagers</h1>
  <div class="container">
    <div class="row mb-3 justify-content-center">
      <div class="col-lg-10 d-flex justify-content-end">
        <!-- Fix the Add button -->
        <button class="btn btn-primary" (click)="openAddModal(wagerModal)">
          <i class="fa fa-plus-circle"></i> Add New Wager
        </button>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <table class="table table-striped table-hover">
          <thead>
          <tr>
            <th>Id</th>
            <th>Abbr</th>
            <th>Custom</th>
            <th>Wager Type</th>
            <th>Name</th>
            <th>Slot</th>
            <th>Actions</th>
          </tr>
          </thead>
          <tbody>
          <!-- Table content -->
          <tr *ngFor="let wagerType of uniqueSpecialWagerTypes">
            <td>{{wagerType.trackId}}</td>
            <td>{{wagerType.trackAbbreviation}}</td>
            <td>{{wagerType.customTrackAbbreviation}}</td>
            <td>{{wagerType.name}}</td>
            <td>{{wagerType.trackName}}</td>
            <td>{{wagerType.slotCount}}</td>
            <td>
              <button class="btn btn-sm btn-outline-primary mr-1" (click)="editWager(wagerType, wagerModal)">
                <i class="fas fa-edit"></i>
              </button>
              <button *ngIf="wagerType.isDeleted === false" class="btn btn-sm btn-outline-danger" (click)="deleteWager(wagerType)">
                <i class="fas fa-trash"></i>
              </button>
              <button *ngIf="wagerType.isDeleted === true" class="btn btn-sm btn-outline-primary" (click)="unDeleteWager(wagerType)">
                <i class="fas fa-check"></i>
              </button>
              <button class="btn btn-sm btn-outline-primary mr-1" (click)="goToRaces(wagerType.id)">
                <i class="fas fa-horse"></i>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>
